import * as React from 'react';
import {
	ContentWrapper,
	LinksWrapper,
	SocialWrapper,
	HomepageFooterWrapper, LogoWrapper,
} from './FooterStyles';
import { LinkColumnLayout } from './Layouts/LinkColumnLayout/LinkColumnLayout';
import { SocialBarLayout } from './Layouts/SocialBarLayout/SocialBarLayout';
import { EnhancedDivider } from '../EnhancedDivider';
import { LinkSchemaType } from '../../Schema/Footer';
import { LinkIndividualSchemaType } from '../../Schema/Footer/LinkSchema';

export type Props = {
	naked: boolean;
	mobile: boolean;
};

export const FooterLayout = (props: Props) => {
	const render = () => {
		const linkSchema: LinkSchemaType = [
		];

		const desktopJSX = (
			<HomepageFooterWrapper>
				<ContentWrapper>
					<LinksWrapper>
						<LogoWrapper>
						</LogoWrapper>
						{generateLinkIndividualSchemas(linkSchema)}
					</LinksWrapper>
					<EnhancedDivider color={'#ccc'}/>
					<SocialWrapper>
						<SocialBarLayout />
					</SocialWrapper>
				</ContentWrapper>
			</HomepageFooterWrapper>
		);
		const mobileJSX = (
			<HomepageFooterWrapper>
				<ContentWrapper>
					<LinksWrapper>
						{generateLinkIndividualSchemas(linkSchema)}
					</LinksWrapper>
					<EnhancedDivider color={'#ccc'}/>
					<SocialWrapper>
						<SocialBarLayout />
					</SocialWrapper>
				</ContentWrapper>
			</HomepageFooterWrapper>
		);
		const returnValue = desktopJSX;
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};

const generateLinkIndividualSchemas = (linkSchema: LinkSchemaType) => {
	const returnValue = linkSchema.map((individualSchema: LinkIndividualSchemaType, index: number) => {
			const innerReturnValue = (<LinkColumnLayout key={'sociallink' + index} linkSchema={individualSchema} />);
			return innerReturnValue;
		}
	);
	return returnValue;
};
